import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import {
  ChangePasswordPage,
  ForgotPasswordPage,
  LoginPage,
  ResetPasswordPage,
  SignupPage,
} from "../auth/AuthPage";
import { SessionBoundary } from "../auth/SessionBoundary";
import { BillingLandingPage } from "../billing-onboarding/BillingLandingPage";
import { MarketingHome } from "../marketing/MarketingHome";
import { InstagramCommentsGuide } from "../marketing/InstagramCommentsGuide";
import guide from "../../../frontend/marketing/instagram-comments-guide.json";
import { SolutionPage } from "../marketing/SolutionPage";
import { SocialCommercePage } from "../marketing/SocialCommercePage";
import { PublicQuotationPage } from "../quotations/PublicQuotationPage";
import { AppRoutes } from "./router";

function routerBasename(): string {
  if (
    window.location.pathname === "/"
    || [guide.path, guide.path.replace(/\/$/, ""), "/instagram-crm", "/instagram-crm/", "/facebook-lead-crm", "/facebook-lead-crm/", "/whatsapp-crm", "/whatsapp-crm/", "/social-commerce", "/social-commerce/"].includes(window.location.pathname)
  ) return "/";
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  return base || "/";
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<MarketingHome />} />
      <Route path={guide.path} element={<InstagramCommentsGuide />} />
      <Route path="instagram-crm" element={<SolutionPage slug="instagram-crm" />} />
      <Route path="facebook-lead-crm" element={<SolutionPage slug="facebook-lead-crm" />} />
      <Route path="whatsapp-crm" element={<SolutionPage slug="whatsapp-crm" />} />
      <Route path="social-commerce" element={<SocialCommercePage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="signup" element={<SignupPage />} />
      <Route path="billing" element={<BillingLandingPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="change-password" element={<ChangePasswordPage />} />
      <Route path="quote/:shareToken" element={<PublicQuotationPage />} />
      <Route path="*" element={<SessionBoundary><AppRoutes /></SessionBoundary>} />
    </>,
  ),
  {
    basename: routerBasename(),
    future: { v7_relativeSplatPath: true },
  },
);

export function App() {
  return <RouterProvider router={router} />;
}
